import { UserProfile } from '@/types/profile'
import { MonthlyAvgDataPoint } from '@/types/otc'

/**
 * Props for DashboardStats component
 * Contains all data needed for stats cards display
 */
export interface DashboardStatsProps {
  // Profile data
  profile?: UserProfile
  
  // Stats data
  totalProjects: number
  totalOrderbookValue: number
  averageDiscount: number
  buyOrders: number
  sellOrders: number
  
  // Loading states
  loading?: boolean
  
  // Chart data
  totalProjectsMonthlyAvg?: MonthlyAvgDataPoint[]
  orderbookMonthlyAvg?: MonthlyAvgDataPoint[]
}

/**
 * Formats monthly average data for chart display
 * Extracts last N months and marks the most recent as highlighted
 */
export const formatChartData = (
  data: MonthlyAvgDataPoint[] | undefined,
  count: number = 3
): Array<{ month: string; value: number; isHighlighted: boolean }> => {
  if (!data || data.length === 0) return []
  
  return data.slice(-count).map((item, index, arr) => {
    const date = new Date(item.date)
    const month = date.toLocaleDateString('en-US', { month: 'short' })
    const isHighlighted = index === arr.length - 1
    
    return {
      month,
      value: item.value,
      isHighlighted
    }
  })
}

